import React, { useEffect, useState } from "react";
import { ButtonCustom, Spacer } from "../../../components";
import { Layout, Navbar } from "../../../containers";
import {
	GET_CITIES,
	GET_PROVINCES,
	GET_DISTRICT,
	GET_SUBDSITRICTS,
} from "../../../services/location.service";
import { mappingForms } from "../../../utils/formsUtils";
import { handleAddAdress, handleEditAdress } from "../handler";
import { LayoutWithAuth } from "../../../containers";
import { Grid, Button, Card } from "@material-ui/core";
import { WrapAlamatMobile } from "../style";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const AlamatTambahPageDesktop = (props) => {
	const [provinces, setProvinces] = useState([]);
	const [cities, setCities] = useState([]);
	const [disctricts, setDisctricts] = useState([]);
	const [subDistricts, setSubdistrics] = useState([]);
	const [formValues, setFormValues] = useState({});
	const [isLoading, setIsLoading] = useState(true);

	let isEdit = props.match.path === "/alamat/edit/:index";
	let index = props.match.params.index;

	useEffect(() => {
		localStorage.removeItem("SHIPPING_SERVICES");
		let local = JSON.parse(localStorage.getItem("ALAMAT_CUSTOMER"));
		const fetch = async () => {
			setFormValues({
				alamatLengkapPenerima: local[index].alamatLengkapPenerima,
				isPrimary: local[index].isPrimary,
				kodePos: local[index].kodePos,
				label: local[index].label,
				namaPenerima: local[index].namaPenerima,
				noTelpPenerima: local[index].noTelpPenerima,
				selectCity: local[index].selectCity,
				selectCityName: local[index].selectCityName,
				selectCityType: local[index].selectCityType,
				selectProvince: local[index].selectProvince,
				selectProvinceName: local[index].selectProvinceName,
				selectDistrict: local[index].selectDistrict,
				selectDistrictName: local[index].selectDistrictName,
				selectSubdistrict: local[index].selectSubdistrict,
				selectSubdistrictName: local[index].selectSubdistrictName,
			});
		};
		setIsLoading(false);
		isEdit && fetch();
	}, [isEdit, props.match.params.index]);

	const forms1 = [
		{
			id: "label",
			label: "Label Alamat",
			type: "text",
			desc: "Contoh : Kantor, Rumah, Kos",
			required: true,
			value: isEdit ? formValues.label : "",
		},
		{
			id: "namaPenerima",
			label: "Nama Penerima",
			type: "text",
			required: true,
			value: isEdit ? formValues.namaPenerima : "",
		},
		{
			id: "noTelpPenerima",
			label: "No. Telepon Penerima",
			type: "text",
			required: true,
			value: isEdit ? formValues.noTelpPenerima : "",
		},
		{
			id: "alamatLengkapPenerima",
			label: "Alamat Lengkap",
			type: "multiline",
			desc: "Contoh : Jl. Naisha no.25 Yogyakarta",
			required: true,
			value: isEdit ? formValues.alamatLengkapPenerima : "",
		},
	];

	const forms2 = [
		{
			id: "selectProvince",
			label: "Pilih Provinsi",
			type: "select",
			options: provinces,
			required: true,
			value: isEdit ? formValues.selectProvince : "",
		},
		{
			id: "selectCity",
			label: "Kota",
			type: "select",
			options: cities,
			required: true,
			value: isEdit ? formValues.selectCity : "",
		},
		{
			id: "selectDistrict",
			label: "Pilih Kecamatan",
			type: "select",
			options: disctricts,
			required: true,
			value: isEdit ? formValues.selectDistrict : "",
		},
		{
			id: "selectSubdistrict",
			label: "Pilih Desa/Kelurahan",
			type: "select",
			options: subDistricts,
			required: true,
			value: isEdit ? formValues.selectSubdistrict : "",
		},
		{
			id: "kodePos",
			label: "Kode Pos",
			type: "number",
			required: true,
			value: isEdit ? formValues.kodePos : formValues.kodePos || "",
		},
	];

	useEffect(() => {
		const fetch = async () => {
			await GET_PROVINCES().then((res) => {
				setProvinces(res);
			});
		};
		fetch();
	}, []);

	useEffect(() => {
		const fetch = async () => {
			await GET_CITIES({
				id: formValues.selectProvince,
			}).then((res) => {
				setCities(res);
			});
		};
		formValues.selectProvince && fetch();
	}, [formValues.selectProvince]);

	useEffect(() => {
		const fetch = async () => {
			await GET_DISTRICT({
				id: formValues.selectCity,
			}).then((res) => {
				setDisctricts(res);
			});
		};
		formValues.selectCity && fetch();
	}, [formValues.selectCity]);

	useEffect(() => {
		const fetch = async () => {
			await GET_SUBDSITRICTS({
				id: formValues.selectDistrict,
			}).then((res) => {
				setSubdistrics(res);
			});
		};
		formValues.selectDistrict && fetch();
	}, [formValues.selectDistrict]);

	useEffect(() => {
		if (formValues.selectSubdistrict) {
			setFormValues({
				...formValues,
				kodePos: subDistricts.find(
					(subdistrict) => subdistrict.id === formValues.selectSubdistrict
				)?.postal_code,
			});
		}
	}, [formValues.selectSubdistrict]);

	return (
		<LayoutWithAuth {...props}>
			<div style={{ marginTop: "32px", minHeight: "calc(100vh - 227px)" }}>
				<div
					style={{
						padding: "14px",
						marginLeft: "8px",
						marginRight: "8px",
					}}>
					<div
						style={{
							borderBottom: "1px solid #EEEEEE",
							paddingBottom: "12px",
						}}>
						<div style={{ display: "flex", alignItems: "center" }}>
							<ArrowBackIcon
								color="primary"
								style={{ marginRight: "8px", cursor: "pointer" }}
								onClick={() => props.history.push("/alamat")}
							/>
							<p>Alamat Pengiriman</p>
						</div>
					</div>
					<Spacer />
					{!isLoading && (
						<WrapAlamatMobile>
							<form
								onSubmit={() =>
									isEdit
										? handleEditAdress(index, formValues, props.history)
										: handleAddAdress(formValues, props.history)
								}>
								<Grid container spacing={2} style={{ padding: 20 }}>
									<Grid item xs={6}>
										<div>{mappingForms(forms1, setFormValues, formValues)}</div>
									</Grid>
									<Grid item xs={6}>
										<div>{mappingForms(forms2, setFormValues, formValues)}</div>
									</Grid>
								</Grid>
								<div style={{ width: "100%" }}>
									<Button
										size="large"
										style={{ width: "100%", color: "white" }}
										color="primary"
										variant="contained"
										type="submit">
										{isEdit ? `Edit` : `Simpan`} Alamat
									</Button>
								</div>
							</form>
						</WrapAlamatMobile>
					)}
				</div>
			</div>
		</LayoutWithAuth>
	);
};

export default AlamatTambahPageDesktop;
